export default __webpack_public_path__ + "static/media/image1.12fbb4e7.png";